import { Easing } from "remotion";
import { linearTiming, springTiming } from "@remotion/transitions";
import { safeInterpolate } from "./interpolate-lib.js";
import { toFrames } from "./frames-lib.js";
/**
 * Gets the duration of the exit transition in frames and seconds, accounting
 * for the transition time having possibly been overwritten by a scene specific
 * transition, or whether the transition is defined by the theme.
 */
export function getTransitionDuration({ exitTransition, sceneTransition, fps, }) {
    let transitionDurationInSeconds = 0;
    let transitionDurationInFrames = 0;
    if (exitTransition && exitTransition.variant !== "none") {
        transitionDurationInSeconds = exitTransition.timing.durationSeconds || 0;
    }
    else {
        if (sceneTransition.variant !== "none") {
            transitionDurationInSeconds = sceneTransition.timing.durationSeconds || 0;
        }
    }
    transitionDurationInFrames = toFrames(transitionDurationInSeconds, fps);
    return { transitionDurationInFrames, transitionDurationInSeconds };
}
export const bezierTiming = (options = {}) => {
    const defaultBezierConfig = { p0: 0.45, p1: 0, p2: 0.55, p3: 1 };
    // Override default config if bezierConfig provided
    const bezierConfig = {
        ...defaultBezierConfig,
        ...options.bezierConfig,
    };
    return {
        getDurationInFrames: () => {
            return options.durationInFrames || 30;
        },
        getProgress: ({ frame }) => {
            // Map the current frame to a 0-1 progress value
            const progress = frame / options.durationInFrames;
            return safeInterpolate(progress, { ideal: [0, 1], safe: "ideal-range-always-increasing" }, [0, 1], {
                easing: Easing.bezier(bezierConfig.p0, bezierConfig.p1, bezierConfig.p2, bezierConfig.p3),
                extrapolateLeft: "clamp",
                extrapolateRight: "clamp",
            });
        },
    };
};
export function getEasingFunction(easing) {
    switch (easing) {
        case "easeIn":
            return Easing.in(Easing.ease);
        case "easeOut":
            return Easing.out(Easing.ease);
        case "easeInOut":
            return Easing.inOut(Easing.ease);
        case "linear":
        default:
            return Easing.linear;
    }
}
export function getTiming(transition, fps) {
    if (transition.variant === "none") {
        return linearTiming({
            durationInFrames: 0,
            easing: getEasingFunction("linear"),
        });
    }
    switch (transition.timing.variant) {
        case "linear":
            return linearTiming({
                durationInFrames: toFrames(transition.timing.durationSeconds, fps),
                easing: getEasingFunction(transition.timing.easing || "linear"),
            });
        case "spring":
            return springTiming({
                config: transition.timing.config,
                durationInFrames: transition.timing.durationSeconds
                    ? toFrames(transition.timing.durationSeconds, fps)
                    : undefined,
            });
        case "bezier":
            return bezierTiming({
                bezierConfig: transition.timing.config,
                durationInFrames: toFrames(transition.timing.durationSeconds, fps),
            });
    }
}
